import React from 'react'

const React_Coding_Practice_35 = () => {
  return (
    <div>
      <h1>Coding Pratice 35</h1>
    </div>
  )
}

export default React_Coding_Practice_35
